export default __webpack_public_path__ + "static/media/man-with-safe.1f5535a4.svg";